import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'
import { actionSet } from './utils'

import {
  FETCH_JUSTIFICATIONS_LINEAR_CONFERENCE_LIST_REQUEST,
  FETCH_JUSTIFICATIONS_LINEAR_CONFERENCE_LIST_SUCCESS,
  FETCH_JUSTIFICATIONS_LINEAR_CONFERENCE_LIST_ERROR,
  UPDATE_JUSTIFICATION_LINEAR_CONFERENCE_REQUEST,
  UPDATE_JUSTIFICATION_LINEAR_CONFERENCE_SUCCESS,
  UPDATE_JUSTIFICATION_LINEAR_CONFERENCE_ERROR,
  GET_PAGES,
} from 'actionTypes'

const getPages = (metadata) => ({
  type: GET_PAGES,
  pages: metadata.pageCount,
  current: metadata.page,
  count: metadata.totalCount,
})

export const getJustificationsLC =
  (token, param = { inInactive: 2 }) =>
  (dispatch) => {
    dispatch(showSpinner())
    dispatch(actionSet(FETCH_JUSTIFICATIONS_LINEAR_CONFERENCE_LIST_REQUEST))

    return new Api(token, dispatch)
      .get(API_URL.LIST_LINEAR_CONFERENCE_JUSTIFICATIONS, param)
      .then((response) => {
        dispatch(getPages(response.data.pagination))
        dispatch(
          actionSet(
            FETCH_JUSTIFICATIONS_LINEAR_CONFERENCE_LIST_SUCCESS,
            response.data.listPresenter
          )
        )
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(
          actionSet(FETCH_JUSTIFICATIONS_LINEAR_CONFERENCE_LIST_ERROR, error)
        )
        dispatch(hideSpinner())
      })
  }

export const updateJustificationLC =
  (token, values, callback) => (dispatch) => {
    dispatch(showSpinner())
    dispatch(actionSet(UPDATE_JUSTIFICATION_LINEAR_CONFERENCE_REQUEST))

    return new Api(token, dispatch)
      .post(API_URL.SAVE_LINEAR_CONFERENCE_JUSTIFICATION, values)
      .then((response) => {
        dispatch(
          actionSet(
            UPDATE_JUSTIFICATION_LINEAR_CONFERENCE_SUCCESS,
            response.data
          )
        )
        dispatch(getJustificationsLC(token))
        if (callback) callback()
      })
      .catch((error) => {
        dispatch(actionSet(UPDATE_JUSTIFICATION_LINEAR_CONFERENCE_ERROR, error))
      })
      .finally(() => dispatch(hideSpinner()))
  }

export const removeJustificationLC = (token, id, callback) => (dispatch) => {
  dispatch(showSpinner())

  return new Api(token, dispatch)
    .post(API_URL.REMOVE_LINEAR_CONFERENCE_JUSTIFICATION, id)
    .then(() => {
      dispatch(getJustificationsLC(token))
      if (callback) callback()
    })
    .catch((error) => {
      dispatch(actionSet(UPDATE_JUSTIFICATION_LINEAR_CONFERENCE_ERROR, error))
    })
    .finally(() => dispatch(hideSpinner()))
}
